import { render, staticRenderFns } from "./ResElectricians.vue?vue&type=template&id=33d3f5c8&scoped=true"
import script from "./ResElectricians.vue?vue&type=script&lang=js"
export * from "./ResElectricians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3f5c8",
  null
  
)

export default component.exports